export const NEW_RELIC_ACCOUNT_ID = import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID
export const NEW_RELIC_AGENT_ID = import.meta.env.VITE_NEW_RELIC_AGENT_ID
export const NEW_RELIC_APPLICATION_ID = import.meta.env
  .VITE_NEW_RELIC_APPLICATION_ID
export const NEW_RELIC_LICENSE_KEY = import.meta.env.VITE_NEW_RELIC_LICENSE_KEY
export const NEW_RELIC_TRUST_KEY = import.meta.env.VITE_NEW_RELIC_TRUST_KEY
